<template>
   <div class='add-btn' @click="$emit('click')">
      <i v-if="icon=='edit'" class="el-icon-edit"></i>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
         <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
         <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
      </svg>
      <slot></slot>
   </div>
</template>

<script>
export default {
   name: 'add-btn',
   props: {
      icon: {
         default: 'add',
         type: String,
      },
   },
}
</script>

<style lang="scss" scoped>
.add-btn {
   font-family: $primary-font;
   width: max-content;
   margin-left: 2px;
   padding: 2px;
   font-size: 0.9em;
   border-radius: 2px;
   display: flex;
   align-items: center;
   color: $font-color;
   cursor: pointer;
   
   svg,i {
      margin-right: 2px;
   }
}
</style>
